module.exports = __webpack_public_path__ + "static/media/ticTacToe.1f220c9a.png";